import { Directive, ElementRef, Input, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { formatSecondsForCuntDown } from "../utils/date.util";

@Directive({
    selector: "[countdown]"
})
export class CountdownDirective implements OnInit, OnDestroy {

    subscription: Subscription = new Subscription();
    @Input() endDate: Date;
    @Input() startDate: Date = new Date();
    @Input() labelOnRight: boolean = true;
    timerInterval: NodeJS.Timeout;
    leftTime: number;
    daysEl: HTMLElement;
    hoursEl: HTMLElement;
    minutesEl: HTMLElement;
    secondsEl: HTMLElement;

    /* 
    *
    *
    To use it just add countdown in html tag that wrap counters, each counter should have an id
    eg:
    <span id="days"></span>
    <span id="hours"></span>
    <span id="minutes"></span>
    <span id="seconds"></span>
    *
    *
    */

    constructor(
        private elementRef: ElementRef
    ) { }


    ngOnInit() {
        this.leftTime = (this.endDate.valueOf() - new Date().valueOf()) / 1000;
        let parentEl = this.elementRef.nativeElement as HTMLElement;
        this.daysEl = parentEl.querySelector("[id^='days']") as HTMLElement;
        this.hoursEl = parentEl.querySelector("[id^='hours']") as HTMLElement;
        this.minutesEl = parentEl.querySelector("[id^='minutes']") as HTMLElement;
        this.secondsEl = parentEl.querySelector("[id^='seconds']") as HTMLElement;

        this.updateCountdown();
        this.startTimer()
    }

    ngOnDestroy(): void {
        clearInterval(this.timerInterval);
    }

    updateCountdown() {
        let leftTimeObj = formatSecondsForCuntDown(this.leftTime);
        if (this.daysEl) this.daysEl.textContent = leftTimeObj.days + '';
        if (this.hoursEl) this.hoursEl.textContent = leftTimeObj.hours + '';
        if (this.minutesEl) this.minutesEl.textContent = leftTimeObj.minutes + '';
        if (this.secondsEl) this.secondsEl.textContent = leftTimeObj.seconds + '';
    }

    startTimer() {
        this.timerInterval = setInterval(() => {
            if (this.leftTime > 0) {
                this.leftTime--;
                this.updateCountdown();
            } else {
                this.stopTimer();
            }
        }, 1000);
    }

    stopTimer() {
        clearInterval(this.timerInterval);
    }

}